// Function for sticky footer
function stickyFooter(){
    var footerHeight = jQuery('.sticky-footer').height(); // get footer height
    jQuery('.push').height(footerHeight); // 
    jQuery('.content-wrapper').css({'marginBottom':'-' + footerHeight + 'px'});
}


// Document Ready
jQuery( document ).ready(function() {
    setTimeout(function(){
        stickyFooter();
    }, 500);
});

// Window resize
jQuery( window ).resize(function() {
    stickyFooter();
}); 